
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subLinks: [],
  showTopbarDropdown: false,
  showThemeDropdown: false,
  showUserRoleDropdown: false,
  showNotificationDropdown: false,
  adresKayitMapSearchOptionsDropdown: false,

  theme: (window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches) ? "light" : "dark",
  theme: "light",
//   theme: "light",
  themeRef: "system",
  activeSelect: null,
  activeContainerSelect: null,
  activeQuesTionMark: null,

  //! nakliye maliyet ile alakalı
  activeNakliyeMaliyetPriceSectionSelect: null,

    //! sidebar state ini tutan
  sidebarState: "wide",

  isSmSidebarHovered: false,

  topStagesState: true,

  garageStatsState: "open",

  customizerState: false,

  diffPageList: [
    "/hesaplamalar/nakliye-fiyat-hesaplama",
    "/hesaplamalar/nakliye-hesaplama",
    "/sari-sayfalar",
    "/hesaplamalar/km-hesaplama",
    "/admin/konum-goruntuleme",
    "/admin/sube-uye-goruntuleme",
    "/log-panel"
  ],

  mustSmSidebarPageList: [
    "/yuk-islemleri/is-listesi",
    "/log-panel"

  ],

  navItemsFromMainLayout: null,
  subLinksFromMainLayout: [],



  //! mobile ********************************************************************************************************************
    mobileTopMargin: "75px",

    mobileMenuOpenedParentPath: null

}

//! sidebar types
//! wide
//! hidden
//! sm-icon

const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {

        handleSidebar: (state, action) => {
            state.sidebarState = action.payload
        },

        handleTopStages: (state, action) => {
            state.topStagesState = action.payload
        },

        handleGarageStats: (state, action) => {
            state.garageStatsState = action.payload
        },

        handleCustomizer: (state, action) => {
            state.customizerState = action.payload
        },

        handleIsSmSidebarHovered: (state, action) => {
            state.isSmSidebarHovered = action.payload
        },

        getSubLinks: (state,action)=> {
            state.subLinks = action.payload
        },
        topbarDropdown: (state)=> {
            state.showTopbarDropdown= !state.showTopbarDropdown
        },
        themeDropdown: (state)=> {
            state.showThemeDropdown= !state.showThemeDropdown
        },
        notificationDropdown: (state) => {
            state.showNotificationDropdown = !state.showNotificationDropdown
        },

        //! bu ileride silinecek
        userRoleDropdown: (state)=> {
            state.showUserRoleDropdown = !state.showUserRoleDropdown
        },
        
        handleTheme: (state, action)=> {
            state.themeRef = action.payload
            if(action.payload === "system"){
                state.theme =(window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches) ? "light" : "dark"
            }
            else{
                state.theme = action.payload
            }
        },
        handleActiveSelect: (state, action)=> {
            state.activeSelect = action.payload
        },

        //! buraya nakliye kısmındaki otoıban-kopru-feribot kısmını kapatıp açtıracak şeyler
        handleNakliyeMaliyetPriceSectionSelect: (state,action) => {
            state.activeNakliyeMaliyetPriceSectionSelect = action.payload
        },

        handleActiveContainerSelect: (state, action)=> {
            state.activeContainerSelect = action.payload
        },
        handleActiveQuestionMark: (state, action)=> {
            state.activeQuesTionMark = action.payload
        },

        handleAdresKayitMapSearchOptionsDropdown: (state, action) => {
            state.adresKayitMapSearchOptionsDropdown = !state.adresKayitMapSearchOptionsDropdown
        },

        setNavItemsFromMainLayout: (state,action) => {
            state.navItemsFromMainLayout = action.payload
        },

        setSubLinksFromMainLayout: (state, action) => {
            state.subLinksFromMainLayout = action.payload
        },


        //! mobile

        setMobileMenuOpenedParentPath: (state, action) => {
            state.mobileMenuOpenedParentPath = action.payload
        },








        clearLayoutState: (state)=> {
            return initialState
        }
    },
})


export const {
    notificationDropdown,
    getSubLinks,
    topbarDropdown,
    themeDropdown,
    handleTopStages,
    handleIsSmSidebarHovered,
    handleGarageStats,
    userRoleDropdown,
    handleTheme,
    handleActiveSelect,
    clearLayoutState,
    handleActiveQuestionMark,
    handleAdresKayitMapSearchOptionsDropdown,
    handleActiveContainerSelect,
    handleNakliyeMaliyetPriceSectionSelect,
    handleSidebar,
    handleCustomizer,
    setNavItemsFromMainLayout,
    setSubLinksFromMainLayout,

    setMobileMenuOpenedParentPath
} = layoutSlice.actions
export default layoutSlice.reducer